// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';
import L from 'leaflet';

myw.MywIcon = L.DivIcon.extend({
    options: {
        orientation: 0
    },

    /**
     * @class Icon allows images to have a width set in m which reacts to map zoom changes or a fixed pixel value,
     * Icon can also have an orientation applied.
     * @extends {L.DivIcon}
     * @constructs
     */
    initialize(options) {
        this.options = options;
        L.Icon.prototype.initialize.call(this);
    },

    createIcon(oldIcon) {
        const div = oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : document.createElement('div');

        const { iconUrl } = this.options;
        const img = document.createElement('img');
        img.src = iconUrl;
        const loaded = new Promise(resolve => {
            img.onload = () => resolve();
        });
        img.style.display = 'none'; // We don't want to see the image until it is positioned and oriented.
        div.appendChild(img);
        this.afterCreate(loaded, img).then(() => {
            this.setWidth(div, img, this.widthCalc());
            this.setOrientation(img, this.options.orientation);
            img.style.removeProperty('display'); // ENH: Can we position and orient before the image is loaded?
            this._setIconStyles(div, 'icon');
        });

        //ENH: get map passed in somehow
        myw.app.map.on('zoomend', () => {
            this.setWidth(div, img, this.widthCalc());
        });
        return div;
    },

    async afterCreate(loaded, img) {
        await loaded;
        this.imageWidth = img.width;
        this.imageHeight = img.height;
    },

    /**
     * Sets the pixel width of an icon
     * @param {number} width
     */
    async setWidth(div, img, width) {
        await this.loaded;

        const delta = width / this.imageWidth;
        div.style.marginLeft = '0px';
        div.style.marginTop = '0px';
        img.style.width = `${width}px`;
        img.style.position = 'relative';
        img.style.left = -this.options.iconAnchor[0] * delta + 'px';
        img.style.top = -this.options.iconAnchor[1] * delta + 'px';

        img.style.transformOrigin = `${this.options.iconAnchor[0] * delta}px ${this.options
            .iconAnchor[1] * delta}px`;
    },

    widthCalc() {
        const map = myw.app.map; //ENH: get map passed in somehow
        if (typeof this.options.width === 'number') return this.options.width;
        if (!this.options.width) return this.imageWidth;

        const [width, dim] = this.options.width.match(/\d+(\.\d+)?|\w/g);

        if (width && dim === 'm') {
            //Point geometry.coordinates [lng,lat]
            //MultiPoint geometry.coordinates [[lng,lat],[lng,lat]]]
            let coords = this.options.feature.geometry.coordinates;
            if (isNaN(coords[0])) {
                coords = coords[0]; //Can used first point of a MultiPoint to calculate width
            }
            const latLng = new L.LatLng(coords[1], coords[0]);
            const latlng2 = map.options.crs.unproject(
                map.options.crs.project(latLng).subtract([parseFloat(width), 0])
            );
            const point = map.latLngToLayerPoint(latLng);
            return (point.x - map.latLngToLayerPoint(latlng2).x) * 2;
        }
        if (width === 'm') return this.imageWidth;
        return this.options.width;
    },

    /**
     * Sets the orientation of an icon
     * @param {number} orientation
     */
    setOrientation(img, orientation) {
        this.options.orientation = orientation;
        img.style.transform = `rotate(${orientation}deg)`;
    }
});

export default myw.MywIcon;
